import { render, staticRenderFns } from "./designEdit.vue?vue&type=template&id=53aec3d8&scoped=true"
import script from "./designEdit.vue?vue&type=script&lang=js"
export * from "./designEdit.vue?vue&type=script&lang=js"
import style0 from "./designEdit.vue?vue&type=style&index=0&id=53aec3d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aec3d8",
  null
  
)

export default component.exports